export default {
  "content": "<path d=\"M13 11.005h7v2h-7v7h-2v-7H4v-2h7v-7h2v7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};